import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../ui/src/component/icon';
import Tag from '../Tag';
import './articleTitle.css';

const ArticleTitle = props => {
  const {pills} = props;

  return (
    <div className="article-title">
      <div className="at-buttons">
        {props.allowShare && (
          <div
            className="at-button"
            onClick={ev => {
              ev.preventDefault();
              props.onClickShare();
            }}
          >
            <Icon name="share" />
          </div>
        )}
      </div>
      <div className="title">
        <div className="at-upper-content">
          {props.tags.map(tag => {
            return <Tag key={tag} title={tag} />;
          })}
        </div>
        <div className="title-content">{props.title}</div>
        {props.subtitle || props.extra ? (
          <div
            className="perex"
          >
            {props.subtitle ? props.subtitle : null}
          </div>
        ) : null}
        {pills}
      </div>
    </div>
  );
};

ArticleTitle.defaultProps = {
  tags: [],
  onClickShare: () => {},
  allowShare: true,
  pills: [],
};

ArticleTitle.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  extra: PropTypes.string,
  tags: PropTypes.array,
  onClickShare: PropTypes.func,
  allowShare: PropTypes.bool,
  pills: PropTypes.array,
};

export default ArticleTitle;



// WEBPACK FOOTER //
// ./src/app/component/standardArticle/articleTitle.js